import Model from '@/models/Model'

export default class WhItem extends Model {

    //
    static includes = [
        'wh_product'
    ]


    resource() {
        return 'wh_item'
    }

    toCreate () {

        return this.clean([
            "alias_name",
            "description",
            "internal_code",
            "name",
            "tags",
            "upc_codes",
            "wh_family_id",
            "wh_subfamily_id",
        ])
    }

    get wh_product_name() {
        return this.getProperty('wh_product.name', '')
    }

    get netPrice (){
        return '0'
    }

    get suggest_internal_code_params() {
        return {
            family_id: Number(this.wh_family_id || 1),
            product_name: String(this.name || ''),
            subfamily_id: Number(this.wh_subfamily_id || 1),
        }
    }
    
}